import React from "react";
import "./Callto.css";
import { Link } from "react-router-dom";
import { IoCallOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa6";

function Callto() {
  return (
    <>
      <div className="footerz">
        <div className="footer-newsletter">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-6 " data-aos="flip-down" >
                {/* <h4>Join Our Newsletter</h4> */}
                <h3 className="pdg">We do whatever it takes to bring you peace of mind</h3>
                <Link to="/form">
                <br />
                  <button className="callback" data-aos="flip-down">
                    {" "}
                    <IoCallOutline /> REQUEST A CALLBACK
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="whats-app" href="https://wa.me/447802416170">
      <FaWhatsapp />
      </a>
    </>
  );
}

export default Callto;
